(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-logos"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  window.onhowScrollingLogos = window.onhowScrollingLogos || {};
  
  window.onhowScrollingLogos.initializedSections = window.onhowScrollingLogos.initializedSections || {};
  
  window.onhowScrollingLogos.pendingTimeouts = window.onhowScrollingLogos.pendingTimeouts || {};
  
  window.onhowScrollingLogos.lastResize = window.onhowScrollingLogos.lastResize || 0;
  
  let hasInitialized = false;
  
  function initializeSections() {
    if (hasInitialized) {
      return;
    }
    
    hasInitialized = true;
    
    for (let id in window.onhowScrollingLogos.pendingTimeouts) {
      clearTimeout(window.onhowScrollingLogos.pendingTimeouts[id]);
    }
    
    window.onhowScrollingLogos.pendingTimeouts = {};
    
    const sections = document.querySelectorAll('.onhow-scrolling-logos-section');
    
    sections.forEach((section) => {
      const sectionId = section.id || `section-${Math.random().toString(36).substr(2, 9)}`;
      
      if (window.onhowScrollingLogos.initializedSections[sectionId]) {
        return;
      }
      
      window.onhowScrollingLogos.initializedSections[sectionId] = true;
      
      window.onhowScrollingLogos.pendingTimeouts[sectionId] = setTimeout(() => {
        initSection(section);
        delete window.onhowScrollingLogos.pendingTimeouts[sectionId];
      }, 200);
    });
  }
  
  async function initSection(section) {
    const track = section.querySelector('.onhow-scrolling-logos-track');
    if (!track) return;
    
    track.classList.remove('onhow-initialized');
    
    await preloadImages(track);
    
    setupTrack(track);
  }

  function handleResize() {
    const now = Date.now();
    if (now - window.onhowScrollingLogos.lastResize < 1000) {
      return;
    }
    
    const sections = document.querySelectorAll('.onhow-scrolling-logos-section');
    let shouldReinitialize = false;
    
    sections.forEach((section) => {
      const track = section.querySelector('.onhow-scrolling-logos-track');
      if (!track) return;
      
      const container = track.parentElement;
      const currentWidth = container.offsetWidth;
      const storedWidth = parseFloat(section.getAttribute('data-last-width') || '0');
      
      if (storedWidth === 0) {
        section.setAttribute('data-last-width', currentWidth);
        return;
      }
      
      if (Math.abs(currentWidth - storedWidth) > 20) {
        shouldReinitialize = true;
        section.setAttribute('data-last-width', currentWidth);
      }
    });
    
    if (shouldReinitialize) {
      window.onhowScrollingLogos.lastResize = now;
      hasInitialized = false;
      window.onhowScrollingLogos.initializedSections = {};
      initializeSections();
    }
  }
  
  function preloadImages(track) {
    return new Promise((resolve) => {
      const images = track.querySelectorAll('img');
      let loadedCount = 0;
      const totalImages = images.length;
      
      if (totalImages === 0) {
        resolve();
        return;
      }
      
      const checkComplete = () => {
        loadedCount++;
        if (loadedCount >= totalImages) {
          resolve();
        }
      };
      
      images.forEach(img => {
        if (img.complete) {
          checkComplete();
          return;
        }
        
        const tempImg = new Image();
        tempImg.onload = checkComplete;
        tempImg.onerror = checkComplete;
        tempImg.src = img.src;
      });
    });
  }
  
  function setupTrack(track) {
    const inner1 = track.querySelector('.onhow-scrolling-logos-inner--1');
    const inner2 = track.querySelector('.onhow-scrolling-logos-inner--2');
    
    if (!inner1 || !inner2) return;
    
    const section = track.closest('.onhow-scrolling-logos-section');
    const containerWidth = track.parentElement.offsetWidth;
    section.setAttribute('data-last-width', containerWidth);
    
    inner1.style.animation = 'none';
    inner2.style.animation = 'none';
    void inner1.offsetWidth; 
    void inner2.offsetWidth; 
    
    const originalItems = inner1.querySelectorAll('.onhow-logo-item');
    if (originalItems.length === 0) return;
    
    const clonedItems = Array.from(originalItems).map(item => item.cloneNode(true));
    
    inner1.innerHTML = '';
    inner2.innerHTML = '';
    
    clonedItems.forEach(item => {
      inner1.appendChild(item.cloneNode(true));
    });
    
    const measuredItems = inner1.querySelectorAll('.onhow-logo-item');
    const originalWidth = Array.from(measuredItems).reduce((sum, item) => {
      const style = window.getComputedStyle(item);
      return sum + item.offsetWidth + 
             parseFloat(style.marginLeft) + 
             parseFloat(style.marginRight);
    }, 0);
    
    const originalCount = measuredItems.length;
    track.setAttribute('data-original-count', originalCount);
    
    const baseScrollSpeed = parseFloat(section.getAttribute('data-scroll-speed')) || 60;
    
    const desiredPxPerSec = originalWidth / baseScrollSpeed;
    
    const containerWidthForCalc = track.parentElement.offsetWidth;
    
    const minTargetWidth = containerWidthForCalc * 3;
    
    const duplicatesNeeded = Math.max(1, Math.ceil(minTargetWidth / originalWidth) - 1);
    
    for (let i = 0; i < duplicatesNeeded; i++) {
      clonedItems.forEach(item => {
        inner1.appendChild(item.cloneNode(true));
        inner2.appendChild(item.cloneNode(true));
      });
    }
    
    clonedItems.forEach(item => {
      inner2.appendChild(item.cloneNode(true));
    });
    
    const finalWidth = originalWidth * (duplicatesNeeded + 1);
    
    inner1.style.width = `${finalWidth}px`;
    inner2.style.width = `${finalWidth}px`;
    
    inner2.style.transform = `translateX(${finalWidth}px)`;
    
    const adjustedDuration = finalWidth / desiredPxPerSec;
    
    track.setAttribute('data-original-width', originalWidth.toFixed(2));
    track.setAttribute('data-final-width', finalWidth.toFixed(2));
    track.setAttribute('data-base-speed', baseScrollSpeed);
    track.setAttribute('data-adjusted-duration', adjustedDuration.toFixed(2));
    
    setTimeout(() => {
      inner1.style.animation = `onhow-scroll-1 ${adjustedDuration}s linear infinite`;
      inner2.style.animation = `onhow-scroll-2 ${adjustedDuration}s linear infinite`;
      
      track.classList.add('onhow-initialized');
    }, 50);
  }
  
  function debounce(func, wait) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSections);
  } else {
    initializeSections();
  }
  
  window.addEventListener('load', initializeSections);
  
  window.addEventListener('resize', debounce(handleResize, 500));
});

  } catch(e) { console.error(e); }
})();
})();
